import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { BiSolidPencil } from 'react-icons/bi';
import { IoMdClose } from 'react-icons/io';

import { ProductSvg } from '../../../../CustomSvg';
import UndraggedDiv from '../../../../Helpers/modal/UndraggedDiv';
import PinGroupAccordion from './PinGroupAccordion';
 
const ProductItem = ({
    product,
    index,
    onEdit,
    onRemove,
    onAddGroupProduct,
    movePinToGroup,
    dropStandaloneToGroup,
    onRefresh,
}) => {
    const canDrag = !product?.positions || product?.positions === null;

    const dragType = canDrag ? 'productpin' : 'productpin_placed';

    const [{ isDragging }, drag, preview] = useDrag({
        type: dragType,
        item: () => ({ index, id: product.enc_id, product }),
        collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    });
 
    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true });
    }, [preview]);
 
    if (product?.type === 2) {
        return (
            <PinGroupAccordion
                product={product}
                drag={drag}
                canDrag={canDrag}
                movePinToGroup={movePinToGroup}
                dropStandaloneToGroup={dropStandaloneToGroup}
                onEdit={onEdit}
                onRemove={onRemove}
                onAddGroupProduct={onAddGroupProduct}
                onRefresh={onRefresh}
            />
        );
    }
 
    return (
        <div
            className="drag-wrpr mxx-3"
            style={{ opacity: isDragging ? 0.4 : 1, transition: 'opacity 0.15s' }}
        >
            <div className={`drag-item ${canDrag ? 'can-drag' : ''}`}>
                <div className="magical-words" ref={drag}>
                    <ProductSvg color={product.product_color ?? '#6A6D73'} />
                    <p>
                        {product.product_name}
                        {product?.floor_plan && ` (${product.floor_plan})`}
                    </p>
                </div>

                <div className="flex-grow-1" />

                {canDrag && <UndraggedDiv pinName="product" />}

                <div
                    className="edit-square magical-words"
                    onClick={() => onEdit?.(product)}
                >
                    <BiSolidPencil fontSize={15} />
                </div>
            </div>

            <div
                className="ml-2 rounded-circle"
                onClick={() => onRemove?.(product, canDrag)}
                style={{
                    backgroundColor: '#E5E5E5',
                    cursor:          'pointer',
                    marginBottom:    8,
                    padding:         4,
                }}
            >
                <IoMdClose fontSize={10} />
            </div>
        </div>
    );
};

export default ProductItem;
